<template>
  <div>
    <div class="renderCustom">
      <div class="firstDateForm" @click="showStartDatePopup = true">
        <span>{{ getNowFormatDate(startDate) }}
          {{ formatDate(startDate).split(' ')[1] }}</span>
      </div>
      <img class="arrow_left" src="@/assets/images/arrow-left-f@2x.png" alt="" />
      <div class="firstDateForm" @click="showEndDatePopup = true">
        <span>{{ getNowFormatDate(endDate) }}
          {{ formatDate(endDate).split(' ')[1] }}</span>
      </div>
    </div>

    <van-checkbox-group v-for="time in customPeriod" :key="time.label" v-model="checkedTimes"
      @change="handleChangeRange">
      <van-checkbox class="rangItem" :name="time.value" :disabled="isExpire(time.value)">{{ time.label
      }}&nbsp;&nbsp;&nbsp;&nbsp;{{ time.value }}</van-checkbox>
    </van-checkbox-group>

    <div class="appointmentTime">
      {{ $t('已选择 ') }}{{ checkedTimes.length }}{{ $t('个时段') }}
    </div>
    <!-- 开始时间 -->
    <van-popup v-model="showStartDatePopup" position="bottom" v-if="showStartDatePopup" @close-on-click-overlay="false">
      <van-datetime-picker type="date" :title="$t('选择年月日')" :value="startDate" :min-date="minDate"
        :max-date="maxStartDate" @confirm="handleConfirmStartDay" @cancel="showStartDatePopup = false" />
    </van-popup>
    <!-- 结束时间 -->
    <van-popup v-model="showEndDatePopup" position="bottom" v-if="showEndDatePopup" @close-on-click-overlay="false">
      <van-datetime-picker type="date" :title="$t('选择年月日')" :value="endDate" :min-date="minDate" :max-date="maxEndDate"
        @confirm="handleConfirmEndDay" @cancel="showEndDatePopup = false" />
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { fixNewDate } from '@/utils/utils'
import {
  getNowFormatDate,
  formatDate,
  formatDateYMDHMS,
  formatDateYMD,
  mergeTimeRanges,
  excludeTimeRanges,
  getRangesByStartEnd,
} from '@/views/station/utils'
import dayjs from 'dayjs'
import moment from 'moment'
import { queryDisableDate } from '@/services/api'
import { Checkbox, CheckboxGroup, Toast } from 'vant'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Toast)

export default {
  name: 'RenderCustom',
  data() {
    return {
      showStartDatePopup: false,
      showEndDatePopup: false,
      startDate: new Date(fixNewDate(this.$route.params.startTime)), // 开始日期（年月日-天）
      endDate: new Date(fixNewDate(this.$route.params.endTime)), // 结束日期（年月日-天）\
      diffNum: 1,
      bookedDates: [],
      checkedTimes: [],
      customPeriod: [],
      minDate: new Date(),
      maxStartDate: new Date(),
      // minEndDate: new Date(),
      maxEndDate: new Date(),
      getNowFormatDate,
      formatDate,
      formatDateYMDHMS,
      mergeTimeRanges,
      getRangesByStartEnd,
    }
  },
  methods: {
    async initQuery() {
      this.checkedTimes = []
      this.customPeriod?.find((v, index) => {
        const time = v.value.split('-')
        const sT = `${dayjs().format('YYYY-MM-DD')} ${time[0]}:00`
        const eT = `${dayjs().format('YYYY-MM-DD')} ${time[1]}:00`
        if (dayjs().isAfter(sT) && dayjs().isBefore(eT)) {
          this.checkedTimes.push(`${time[0]}-${time[1]}`)
        }
      })
      this.handleChangeRange(this.checkedTimes)
      // 初始化更新一下值
      // let rangeDateForSubmit = []

      // this.onChangeDate('start', this.startDate, new Date(`${formatDateYMD(this.endDate)} 23:59:59`), rangeDateForSubmit)
      // this.onChangeDate(
      //   'end',
      //   new Date(`${formatDateYMD(this.endDate)} 23:59:59`),
      //   rangeDateForSubmit
      // )

      const maxMakeDay = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      //   singleMaxMakeTime = this.appointmentConfig.singleMaxMakeTime
      //     ? this.appointmentConfig.singleMaxMakeTime
      //     : 5 // 单次最长预约天数
      try {
        const res = await queryDisableDate({
          stationId: this.checkedStationId,
          startTime: `${dayjs().format('YYYY-MM-DD')} 00:00:00`,
          endTime: `${dayjs()
            .add(maxMakeDay, 'day')
            .format('YYYY-MM-DD')} 23:59:59`,
          type: 'CUSTOM_TIME',
        })
        let sortByStartTime = []
        // 1. 按照开始时间进行生序
        sortByStartTime = res?.data.sort(
          (a, b) =>
            moment(a.startTime).valueOf() - moment(b.startTime).valueOf()
        )
        // 2. 相邻的时间段进行合并
        let newDateList = this.mergeTimeRanges(sortByStartTime)

        this.bookedDates = newDateList
      } catch (error) {
        console.log(error)
      }
    },
    initSetDate() {
      this.checkedTimes = []
      this.customPeriod?.find((v, index) => {
        const time = v.value.split('-')
        const sT = `${dayjs().format('YYYY-MM-DD')} ${time[0]}:00`
        const eT = `${dayjs().format('YYYY-MM-DD')} ${time[1]}:00`
        if (dayjs().isAfter(sT) && dayjs().isBefore(eT)) {
          if (dayjs().isAfter(sT) && dayjs().isBefore(eT)) {
            this.checkedTimes.push(`${time[0]}-${time[1]}`)
          }
        }
      })
      this.handleChangeRange(this.checkedTimes)
      const maxDate = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间

      let maxStartDate = new Date()
      // maxStartDate.setDate(this.startDate.getDate() + Number(maxDate) - 1)
      maxStartDate.setDate(new Date().getDate() + Number(maxDate) - 1)
      this.maxStartDate = maxStartDate

      let maxEndDate = new Date(this.startDate)
      maxEndDate.setDate(this.startDate.getDate() + Number(singleMaxMakeTime) - 1)
      if (maxEndDate.getTime() > maxStartDate.getTime()) {
        this.maxEndDate = maxStartDate
      } else {
        this.maxEndDate = maxEndDate
      }
      // this.maxEndDate = maxEndDate
    },
    // 根据配置的最大预约时间显示过滤数据
    filterStartDay(type, options, day) {
      const currentCheckedDate = dayjs(day)
      const curY = dayjs().year()
      const curM = Number(dayjs().format('MM'))
      const curD = Number(dayjs().format('DD'))

      const maxDate = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      const maxMakeDay = dayjs().add(maxDate - 1, 'day') //最大预约天数

      const maxY = maxMakeDay.year()
      const maxM = Number(maxMakeDay.format('MM'))
      const maxD = Number(maxMakeDay.format('DD'))

      const isCurY =
        dayjs().format('YYYY') === currentCheckedDate.format('YYYY')
      const isCurM =
        dayjs().format('YYYY-MM') === currentCheckedDate.format('YYYY-MM')
      const checkedY = currentCheckedDate.year()
      const checkedM = currentCheckedDate.month() + 1

      if (type === 'year') {
        return options.filter(
          (option) => Number(option) >= curY && Number(option) <= maxY
        )
      }
      if (type === 'month') {
        if (isCurY) {
          if (checkedY === maxY) {
            return options.filter(
              (option) => Number(option) >= curM && Number(option) <= maxM
            )
          } else {
            return options.filter((option) => Number(option) >= curM)
          }
        } else {
          if (checkedY === maxY) {
            return options.filter((option) => Number(option) <= maxM)
          }
        }
      }
      if (type === 'day') {
        if (isCurY) {
          if (checkedY === maxY) {
            if (isCurM) {
              if (checkedM === maxM) {
                return options.filter(
                  (option) => Number(option) >= curD && Number(option) <= maxD
                )
              } else {
                return options.filter((option) => Number(option) >= curD)
              }
            } else {
              if (checkedM === maxM) {
                return options.filter((option) => Number(option) <= maxD)
              }
            }
          }
        } else {
          if (checkedY === maxY) {
            if (checkedM === maxM) {
              return options.filter((option) => Number(option) <= maxD)
            }
          }
        }
      }
      return options
    },
    filterEndDay(type, options) {
      const currentCheckedDate = dayjs(this.startDate)
      const curY = dayjs().year()
      const curM = Number(dayjs().format('MM'))
      const curD = Number(dayjs().format('DD'))

      // const maxDate = this.appointmentConfig.maxMakeDay ? this.appointmentConfig.maxMakeDay : 20 // 最长预约天数
      // const singleMaxMakeTime = this.appointmentConfig.singleMaxMakeTime
      //   ? this.appointmentConfig.singleMaxMakeTime
      //   : 5 // 单次最长预约天数

      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间
      const maxMakeDay = dayjs().add(singleMaxMakeTime - 1, 'day') //最大预约天数

      const maxY = maxMakeDay.year()
      const maxM = Number(maxMakeDay.format('MM'))
      const maxD = Number(maxMakeDay.format('DD'))

      const isCurY =
        dayjs().format('YYYY') === currentCheckedDate.format('YYYY')
      const isCurM =
        dayjs().format('YYYY-MM') === currentCheckedDate.format('YYYY-MM')
      const checkedY = currentCheckedDate.year()
      const checkedM = currentCheckedDate.month() + 1

      if (type === 'year') {
        return options.filter(
          (option) => Number(option) >= curY && Number(option) <= maxY
        )
      }
      if (type === 'month') {
        if (isCurY) {
          if (checkedY === maxY) {
            return options.filter(
              (option) => Number(option) >= curM && Number(option) <= maxM
            )
          } else {
            return options.filter((option) => Number(option) >= curM)
          }
        } else {
          if (checkedY === maxY) {
            return options.filter((option) => Number(option) <= maxM)
          }
        }
      }
      if (type === 'day') {
        if (isCurY) {
          if (checkedY === maxY) {
            if (isCurM) {
              if (checkedM === maxM) {
                return options.filter(
                  (option) => Number(option) >= curD && Number(option) <= maxD
                )
              } else {
                return options.filter((option) => Number(option) >= curD)
              }
            } else {
              if (checkedM === maxM) {
                return options.filter((option) => Number(option) <= maxD)
              }
            }
          }
        } else {
          if (checkedY === maxY) {
            if (checkedM === maxM) {
              return options.filter((option) => Number(option) <= maxD)
            }
          }
        }
      }
      return options
    },
    // 过滤年月日-开始
    filterStartDateDay(type, options) {
      const curOptions = this.filterStartDay(type, options, this.startDate)
      return curOptions
    },
    // 过滤年月日-结束
    filterEndDateDay(type, options) {
      const curOptions = this.filterEndDay(type, options, this.endDate)
      return curOptions
    },
    /**
     *
     * @param checkedDate 选中的日期
     * @param checkedTimes 选中的时间
     */
    getRangeDateForSubmit(checkedDate, checkedTimes) {
      let newForSubmitDates = []
      checkedDate.forEach((date) => {
        checkedTimes.forEach((times) => {
          const s = times.split('-')[0]
          const e = times.split('-')[1]
          newForSubmitDates.push({
            startTime: `${moment(date.startTime).format('YYYY-MM-DD')} ${s}:00`,
            endTime: `${moment(date.startTime).format('YYYY-MM-DD')} ${e}:00`,
          })
        })
      })
      return newForSubmitDates
    },
    // 确认开始 天
    handleConfirmStartDay(date) {
      let time1 = dayjs(date).format('YYYY-MM-DD HH:mm:ss').split(' ')[0]
      let time2 = dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let time3 = dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let timeS = time1 + ' ' + time2
      let timeE = time1 + ' ' + time3
      date = new Date(fixNewDate(timeS))
      let dateE = new Date(fixNewDate(timeE))
      this.startDate = date

      this.showStartDatePopup = false
      this.endDate = dateE

      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间
      let maxEndDate = new Date(this.startDate)
      maxEndDate.setDate(
        this.startDate.getDate() + Number(singleMaxMakeTime) - 1
      )
      if (maxEndDate.getTime() > this.maxStartDate.getTime()) {
        this.maxEndDate = this.maxStartDate
      } else {
        this.maxEndDate = maxEndDate
      }

      this.diffNum = dayjs(this.endDate).diff(this.endDate, 'day')

      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate)
      )

      let newForSubmitDates = this.getRangeDateForSubmit(
        rangeDateForSubmit,
        this.checkedTimes
      )
      // 过滤已经过期的日期
      newForSubmitDates = newForSubmitDates.filter((date) =>
        moment().isBefore(date.endTime, 'minute')
      )

      this.onChangeDate('start', date, dateE, newForSubmitDates)
      // this.onChangeDate('end', dateE, newForSubmitDates)
    },
    handleConfirmEndDay(date) {
      let time1 = dayjs(date).format('YYYY-MM-DD HH:mm:ss').split(' ')[0]
      let time2 = dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let time3 = dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let time = time1 + ' ' + time2
      let timeS = time1 + ' ' + time3
      date = new Date(fixNewDate(time))
      this.endDate = date
      this.showEndDatePopup = false

      if (dayjs(date).isBefore(this.startDate)) {
        this.startDate = new Date(fixNewDate(timeS))
      }

      let diff =
        moment(formatDateYMDHMS(this.endDate)).diff(
          formatDateYMDHMS(this.startDate),
          'day'
        ) + 1
      // 计算已经预约的天数
      let bookedNum = 0 // 已经预约的天数
      this.bookedDates.forEach((v) => {
        bookedNum += moment(v.endTime).diff(v.startTime, 'day') + 1
      })
      // 控件选择的总天数，减去已经预约的天数
      diff = diff - bookedNum

      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间
      if (diff > singleMaxMakeTime) {
        Toast(this.$t('超过了单次可预约的最大天数'))
        this.startDate = new Date(fixNewDate(timeS))
        diff = 1
      }

      this.diffNum = diff

      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate)
      )

      let newForSubmitDates = this.getRangeDateForSubmit(
        rangeDateForSubmit,
        this.checkedTimes
      )

      // 过滤已经过期的日期
      newForSubmitDates = newForSubmitDates.filter((date) =>
        moment().isBefore(date.endTime, 'minute')
      )
      this.onChangeDate('start', this.startDate, date, newForSubmitDates)
      // this.onChangeDate('end', date, newForSubmitDates)
    },
    handleChangeRange(values) {
      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate)
      )

      let newForSubmitDates = this.getRangeDateForSubmit(
        rangeDateForSubmit,
        values
      )
      // 过滤已经过期的日期
      newForSubmitDates = newForSubmitDates.filter((date) =>
        moment().isBefore(date.endTime, 'minute')
      )
      if (values && values.length) {
        let list = values.map(item => {
          return {
            startTime: item.split('-')[0],
            endTime: item.split('-')[1],
          }
        })
        const earliestStartEvent = list.reduce((prev, current) => {
          const prevTime = dayjs(prev.startTime, "HH:mm");
          const currentTime = dayjs(current.startTime, "HH:mm");
          return prevTime.isBefore(currentTime) ? prev : current;
        });
        const latestEndEvent = list.reduce((prev, current) => {
          const prevTime = dayjs(prev.endTime, "HH:mm");
          const currentTime = dayjs(current.endTime, "HH:mm");
          return prevTime.isAfter(currentTime) ? prev : current;
        });
        let startDate = `${moment(this.startDate).format('YYYY-MM-DD')} ${earliestStartEvent.startTime
          }:00`
        let endDate = `${moment(this.endDate).format('YYYY-MM-DD')} ${latestEndEvent.endTime
          }:00`
        this.startDate = new Date(fixNewDate(startDate))
        this.endDate = new Date(fixNewDate(endDate))
        this.onChangeDate('start', startDate, endDate, newForSubmitDates)
        // this.onChangeDate('end', endDate, newForSubmitDates)
      } else {
        let startDate = `${moment(this.startDate).format('YYYY-MM-DD')} 00:00:00`
        let endDate = `${moment(this.endDate).format('YYYY-MM-DD')} 23:59:59`
        this.startDate = new Date(fixNewDate(startDate))
        this.endDate = new Date(fixNewDate(endDate))
        this.onChangeDate('start', startDate, endDate, newForSubmitDates)
        // this.onChangeDate('end', endDate, newForSubmitDates)
      }

    },
    /**
     * 当天已过时间段，禁止点击，非当天且跨天不禁止
     * @param times
     * @returns
     */
    isExpire(times) {
      if (moment(this.startDate).isSame(this.endDate, 'day')) {
        // 只有选择了一天的情况下，才进行时段禁止显示。
        // 是当天时间，已过期的禁止；非当天的，已预约的禁止
        const isToday = moment().isSame(this.startDate, 'day')
        const time = times.split('-')

        const item = {
          startTime: `${moment(this.startDate).format('YYYY-MM-DD')} ${time[0]
            }:00`,
          endTime: `${moment(this.startDate).format('YYYY-MM-DD')} ${time[1]
            }:00`,
        }

        let isExpire = false
        if (isToday) {
          // 当天
          const eTime = `${moment().format('YYYY-MM-DD')} ${time[1]}:00`
          isExpire = moment().isAfter(eTime, 'minute')
        }
        // 当前时间是否已经预约过了
        const isExit = this.bookedDates.find(
          (v) =>
            (v.startTime === item.startTime && v.endTime === item.endTime) ||
            (dayjs(item.startTime).isSameOrAfter(v.startTime) &&
              dayjs(item.endTime).isSameOrBefore(v.endTime))
        )

        return !!isExit || isExpire
      } else {
        return false
      }
    },
  },
  mounted() {
    this.customPeriod = this.appointmentConfig?.customPeriod
      ? JSON.parse(this.appointmentConfig.customPeriod)
      : []
    this.initSetDate()
  },
  watch: {
    checkedStationId(newValue, oldValue) {
      newValue && this.initQuery()
    },
  },
  props: ['appointmentConfig', 'onChangeDate', 'checkedStationId'],
}
</script>
<style lang="less" scoped>
.renderCustom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;

  .firstDateForm {
    display: flex;
    flex-direction: column;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;

      font-size: 16px;
      color: #1e2329;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .arrow_left {
    width: 24px;
    height: 24px;
  }
}

.rangItem {
  padding: 12px 0;
  border-bottom: 1px solid #e2e8f6;
}

.appointmentTime {
  padding: 10px 0 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b7bdc6;
  border-top: 1px solid rgba(234, 236, 239, 0.5);
}
</style>
